export default __webpack_public_path__ + "static/media/44.d8d1cce3.svg";